export default __webpack_public_path__ + "static/media/AR-card.a871c9bb.jpg";